import { ListingBuyerModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const ListingBuyerEntityData = createEntityDataContext<ListingBuyerModel>();
